import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from '@codex/basics';
import { Icon } from '@codex/icons';


const StyledIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  margin: -5px 10px -5px 0px;
`;


export default function AddToBasketButton(props) {

  const buttonIcon = props.download
    ? <StyledIcon icon={'Download'} /> : <StyledIcon icon={'AddToBasket'} />;

  return (
    <Button
      full
      positive={!props.download}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.showSpinner
        ? <StyledIcon icon={'Spinner'} spin />
        : buttonIcon}
      {props.buttonLabel}
    </Button>
  );
}

AddToBasketButton.displayName = 'AddToBasketButton';

AddToBasketButton.propTypes = {
  download: PropTypes.bool,
  buttonLabel: PropTypes.string,
  disabled: PropTypes.bool,
  showSpinner: PropTypes.bool,
  onClick: PropTypes.func

};

AddToBasketButton.defaultProps = {
  download: false,
  buttonLabel: 'No Label',
  disabled: false,
  showSpinner: false,
  onClick: () => {}
};
